var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whole-page",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"navbar-div"},[_c('NavbarComponent',{attrs:{"user":_vm.user,"analysis":"SUPERVISOR"}})],1),_vm._v("\n    que si\n")])}
var staticRenderFns = []

export { render, staticRenderFns }